import { getServiceURL } from '../transportWrapper';

import { ILegacySavedView } from '../types';

const legacySavedViewsApi = getServiceURL(process.env.DELPHIUS_DEFAULT_HOST);

export const getSavedViewById = async (id: string | number, clientOptions?: RequestInit): Promise<ILegacySavedView> =>
  legacySavedViewsApi
    .options(clientOptions, true)
    .url(`/api/v1/saved_views/${id}`)
    .get()
    .json((savedView: ILegacySavedView) => savedView);

export const getSavedViewsByReportIdWithLimit = async (
  params: { report_id: string | number; limit?: number },
  clientOptions?: RequestInit
): Promise<ILegacySavedView[]> =>
  legacySavedViewsApi
    .options(clientOptions, true)
    .url(`/api/v1/saved_views`)
    .query(params)
    .get()
    .json((response: { saved_views: ILegacySavedView[] }) => response.saved_views);
